import { render, staticRenderFns } from "./TextEditorTinyCoupon.vue?vue&type=template&id=31cac8e4&scoped=true"
import script from "./TextEditorTinyCoupon.vue?vue&type=script&lang=js"
export * from "./TextEditorTinyCoupon.vue?vue&type=script&lang=js"
import style0 from "./TextEditorTinyCoupon.vue?vue&type=style&index=0&id=31cac8e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31cac8e4",
  null
  
)

export default component.exports